const path = `/v2/organization/bulkenrollments/json/uploads`;
/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  /**
   *
   * @param {Object} param0
   * @param {Array} param0.enrollments
   * @param {String} param0.type
   * @param {String} param0.distribution
   * @param {Boolean} param0.skip Default true, allows invalid numbers to be skipped
   */
  async function create({ enrollments, type, distribution, skip }) {
    const response = await repository.post(path, {
      enrollments,
      type,
      distribution,
      skip
    });
    return response && response.data ? response.data || {} : null;
  }
  return Object.freeze({
    create
  });
}
